import { render, staticRenderFns } from "./Coworkers.vue?vue&type=template&id=5afcfb64&"
import script from "./Coworkers.vue?vue&type=script&lang=js&"
export * from "./Coworkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports